import { Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';

import { useEstimatedTimeTooltipStyles } from './EstimatedTimeTooltip.styles';

const {
  FAIcon,
} = require('../../../../components/adapters/fontAwesomeAdapters');

const EstimatedTimeTooltip = ({ children, titleId }) => {
  const { styles } = useEstimatedTimeTooltipStyles();
  return (
    <Tooltip
      classNames={{ root: styles.quoteTooltipOverlay }}
      title={() => (
        <div className={styles.quoteTooltipContent}>
          <FAIcon icon="info-circle" />
          <div className="nl-as-newline">
            <FormattedMessage id={titleId} />
          </div>
        </div>
      )}
      placement="top"
    >
      {children}
    </Tooltip>
  );
};

export default EstimatedTimeTooltip;
